import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
import { images } from '../data/offer';
type Notice = {
  name: string;
  country: string;
  minutes: number;
};
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * buyers.length);
    let hideTimer: number;
    const show = () => {
      const b = buyers[index % buyers.length];
      index += 1;
      setNotice({
        ...b,
        minutes: 1 + Math.floor(Math.random() * 14)
      });
      hideTimer = window.setTimeout(() => setNotice(null), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-[96px] left-3 z-50 w-[calc(100%-1.5rem)] max-w-sm sm:bottom-28 sm:left-5" aria-live="polite" data-id="element-25" data-mp="163mo17mfhyy7">
      <AnimatePresence data-id="element-26" data-mp="1fur2854a5frz">
        {notice && !dismissed && <motion.div key={notice.name + notice.minutes} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_20px_40px_-12px_rgba(5,11,22,0.45)] ring-1 ring-slate-200" data-id="element-27" data-mp="1awpmnu62byl9">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-paper object-contain" data-id="element-28" data-mp="28kg3mjkwjhu4" />
            <div className="min-w-0" data-id="element-29" data-mp="23lmzvivf3575">
              <p className="text-sm leading-snug text-ink" data-id="element-30" data-mp="23kleolkot2bp">
                <span className="font-bold" data-id="element-31" data-mp="2aothw6inzjez">{notice.name}</span> from <span className="font-bold" data-id="element-32" data-mp="2aobf0r1hy6y3">{notice.country}</span> just purchased the
                Low Back Pain Assessment Blueprint™
              </p>
              <p className="mt-1 flex items-center gap-1 text-xs font-medium text-emerald-700" data-id="element-33" data-mp="2km7qjjycj3wq">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-34" data-mp="2pmdiz2cfwufv" />
                Verified purchase · {notice.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-slate-500 transition-colors duration-150 hover:bg-slate-100 hover:text-ink" aria-label="Dismiss notification" data-id="element-35" data-mp="1rw8wtb97iilq">
              <XIcon className="h-4 w-4" data-id="element-36" data-mp="197lpsn7gzj5i" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}